export const ERROR_LOG = false;
// export const ERROR_LOG = true;
// export const PROXY_ADR = 'http://172.20.2.247:3000';
export const PROXY_ADR = 'http://localhost:3000';
